import { useMutation, useQuery } from 'react-query';
import taskApi from '../apis/getTask';

const { getTask } = taskApi;
export const useGetTask = (
  remark,
  requestId,
  onSuccess,
  onError
) =>
  useQuery(
    [
      '' + remark,
      requestId
    ],
    () =>
      getTask(
        requestId
      ),
    {
      onSuccess,
      onError,
    }
  );
